export default {
  Meta: {
    Title: '@:Promotion.Terms.SubTitle'
  },

  Home: {
    Title   : 'Join the Pirelli Family and Win!',
    SubTitle: 'Get new Pirelli tires!',
    Slogan  : 'Enjoy efficient, safe driving and unique benefits!',
  },

  Terms: {
    Title   : 'Promotion Terms',
    SubTitle: 'TYRELIFE Promotion',
    Body    : `
        <p>
          <h3>ΠΡΟΩΘΗΤΙΚΗ ΕΝΕΡΓΕΙΑ TYRELIFE</h3>
          <p>Η ΕΛΑΣΤΙΚΑ PIRELLI ΑΕΕ (στο εξής “Pirelli”) και οι μεταπωλητές που συμμετέχουν στην προωθητική ενέργεια (ο κατάλογος των συμμετεχόντων μεταπωλητών δημοσιεύεται στην ιστοσελίδα: <a href="https://www.pirelli.gr/" target="_blank">www.pirelli.gr</a>) προσφέρουν με την κάρτα TYRELIFE σημαντικά οφέλη στους αγοραστές επιβατικών ελαστικών Pirelli εκτός των ελαστικών Run-Flat και των ελαστικών για ελαφρά φορτηγά. Το πρόγραμμα λειτουργεί ανεξάρτητα από τις άλλες προωθητικές ενέργειες της Pirelli και των ενεργειών των εταιρειών του γκρουπ της Pirelli.</p>
        </p>

        <p>
          <h3>ΠΛΑΙΣΙΟ ΚΑΙ ΙΣΧΥΣ</h3>
          <p>Η ενέργεια ισχύει για αγορά 4 ελαστικών Pirelli (με βάση την ανάλυση στην προηγούμενη παράγραφο), που πραγματοποιείται στην έδρα των μεταπωλητών που συμμετέχουν στην ενέργεια Tyrelife. Η ενέργεια απευθύνεται αποκλειστικά σε φυσικά πρόσωπα και εφαρμόζεται μόνο σε οχήματα ιδιωτικής χρήσης (ΙΧ) κυριότητας αυτών. Η κατοχή, χρήση ή μίσθωση (leasing) οχήματος δεν παρέχει δικαίωμα συμμετοχής στην ενέργεια. Το ενδιαφερόμενο να συμμετάσχει στην ενέργεια φυσικό πρόσωπο οφείλει να επιδεικνύει στον μεταπωλητή την άδεια κυκλοφορίας του οχήματος προκειμένου να αποδεικνύει ότι είναι ιδιοκτήτης αυτού. Μεταπωλητής, ο οποίος εγγράφει στην ενέργεια τελικό καταναλωτή δίχως να πληρούνται οι ανωτέρω προϋποθέσεις, φέρει την αποκλειστική ευθύνη έναντι του τελικού καταναλωτή. Ο τελικός καταναλωτής θα μπορεί να επωφεληθεί της ενέργειας για μέγιστο αριθμό 3 οχημάτων στο όνομά του.</p>
          <p>
          Οι μεταπωλητές που συμμετέχουν στην ενέργεια θα πραγματοποιήσουν την δωρεάν αντικατάσταση ενός ελαστικού του ιδίου τύπου και διαστάσεων, σε περίπτωση που το χρησιμοποιούμενο ελαστικό έχει υποστεί ζημιές που δεν μπορούν να επιδιορθωθούν λόγω των παρακάτω τυχαίων γεγονότων:</br>
          - κλατάρισμα</br>
          - σύγκρουση στο πεζοδρόμιο ή σε άλλο εμπόδιο</br>
          - πυρκαγιά
          </p>
          <p>Παραμένουν σε ισχύ οι εγγυήσεις του παραγωγού και του πωλητή βάσει της ισχύουσας νομοθεσίας.</p>
          <p>Η αντικατάσταση μπορεί να ζητηθεί εντός των παρακάτω ορίων και σε σχέση με τις συνθήκες που αναφέρονται στη συνέχεια: Μέχρι 12 μήνες από την ημερομηνία αγοράς. Αντικατάσταση του ελαστικού που έχει υποστεί ζημιές με ελαστικό του ιδίου τύπου και διαστάσεων. Τα κόστη τοποθέτησης και ζυγοστάθμισης του ελαστικού που αντικαταστάθηκε, θα επιβαρύνουν τον τελικό καταναλωτή.</p>
        </p>

        <p>
          <h3>ΟΡΟΙ ΓΙΑ ΤΗΝ ΑΝΤΙΚΑΤΑΣΤΑΣΗ ΤΟΥ ΕΛΑΣΤΙΚΟΥ</h3>
          <p>Θα είναι δυνατή η επίτευξη της δωρεάν αντικατάστασης του ελαστικού με τους εξής όρους:</p>
          <ol>
            <li>Οι ζημιές του ελαστικού να μην έχουν προκληθεί σκοπίμως ή κατόπιν δόλιας συμπεριφοράς.</li>
            <li>Το υπολειπόμενο πέλμα του ελαστικού να είναι μεγαλύτερο από 1,6 χιλ, το ελαστικό να έχει χρησιμοποιηθεί σωστά για τη χρήση για την οποία προορίζεται και σεβόμενοι πλήρως τους κανονισμούς και τα τεχνικά χαρακτηριστικά που υποδεικνύονται από την Pirelli και/ή από τους συμμετέχοντες στην ενέργεια Tyrelife μεταπωλητές.</li>
            <li>Ο καταναλωτής να παραδώσει το ελαστικό που έχει υποστεί ζημία στους συμμετέχοντες στην ενέργεια Tyrelife μεταπωλητές, εξουσιοδοτώντας την διάθεσή του ως απόβλητο σύμφωνα με την ισχύουσα νομοθεσία.</li>
            <li>Η κάρτα Tyrelife να μην έχει παραχωρηθεί σε τρίτους και να επιδεικνύεται κατά τη στιγμή της αντικατάστασης.</li>
            <li>Η φορολογική απόδειξη που αποδεικνύει την αγορά του ελαστικού πρέπει να διατηρηθεί και να επιδεικνύεται κατά τη στιγμή της αντικατάστασης.</li>
            <li>Το προνόμιο δωρεάν αντικατάστασης παρέχεται για ένα εκ των 4 ελαστικών που έχει αγοράσει ο τελικός καταναλωτής.</li>
          </ol>
        </p>

        <p>
          <h3>ΟΔΗΓΙΕΣ ΚΑΙ ΕΦΑΡΜΟΓΗ ΤΗΣ ΠΡΟΩΘΗΤΙΚΗΣ ΕΝΕΡΓΕΙΑΣ TYRELIFE</h3>
          <p>Η PIRELLI δεν είναι σε καμία περίπτωση υπεύθυνη για τις ενέργειες των μεταπωλητών, οι οποίο ενεργούν σε πλήρη αυτονομία και με πλήρη ανάληψη ευθύνης σε σχέση με τις δραστηριότητες που θα πραγματοποιήσουν στα πλαίσια της ενέργειας Tyrelife.</p>
        </p>
    `
  },

  Form: {
    Title      : 'Enter your details',
    SubTitle   : 'Join Pirelli Reward programs with unique offers!',
    Fields     : {
      Firstname  : { Label: 'Firstname', Hint: 'Firstname' },
      Lastname   : { Label: 'Lastname', Hint: 'Lastname' },
      ZipCode    : { Label: 'Post Code', Hint: 'Postal code of residence' },
      Email      : { Label: 'Email', Hint: 'Contact Email' },
      Phone      : { Label: 'Mobile', Hint: 'Mobile phone number' },
      IsCompany  : { Label: 'Company', Hint: 'Company' },
      CompanyName: { Label: 'Company Name', Hint: 'Company name' },
      PlateNumber: { Label: 'Plate', Hint: 'Vehicle license plate number' },
      BrandId    : { Label: 'Brand', Hint: 'Vehicle Brand' },
      CarId      : { Label: 'Model', Hint: 'Vehicle Model' },
      Privacy    : { Label: 'I have read & accept the', Hint: '' },
      Terms      : { Label: 'I have read & accept the', Single: 'terms', Hint: 'of the promotion' },
      GDPR       : {
        SMS  : { Label: 'Text message (SMS, WhatsApp or others)', Hint: '' },
        Phone: { Label: 'Phone', Hint: '' },
        Email: { Label: 'E-mail', Hint: '' },
        All  : { Label: 'All the above', Hint: '' },
      }
    },
    PrivacyText: 'Privacy Notice',
    NoticeHint : 'The following information is collected on behalf of PIRELLI SA for your participation in the promotion and will be transmitted to Wunderman Advertising SA Greece, to contact you. Your data is collected for the purposes of this promotion and for as long as it lasts. For more information, see the',
    TermsHint  : 'In order for your participation to be valid and to be able to contact you, please select:',
    GDPRHint   : 'I wish to receive direct promotional material from Pirelli in accordance with the Privacy Policy through:',
  }

}
